import React, { useState } from 'react';
import { AdminHeader } from './components/AdminHeader';
import { CreateNoticeForm } from './components/CreateNoticeForm';
import { Sidebar } from './components/Sidebar';
import { RequetesModule } from './components/RequetesModule';
import { PermisModule } from './components/PermisModule';
import { LoisirsModule } from './components/LoisirsModule';
import { BcitiIdModule } from './components/BcitiIdModule';
import { BcitiCollectesModule } from './components/BcitiCollectesModule';
import { BcitiCompteursModule } from './components/BcitiCompteursModule';
import { AtnaModule } from './components/AtnaModule';
import { SettingsModule } from './components/SettingsModule';
import { useScreenInit } from './useScreenInit.js';
import { LanguageProvider } from './contexts/LanguageContext';
import { CityProvider } from './contexts/CityContext';
import { AccountProvider } from './contexts/AccountContext';
export function App() {
  const screenInit = useScreenInit();
  const [activeTab, setActiveTab] = useState(screenInit.activeTab ?? 'requetes');
  return <LanguageProvider data-id="element-0" data-mp="3ihv1ac76whht">
      <CityProvider data-id="element-1" data-mp="3mlavl1vse5rc">
      <AccountProvider data-id="element-2" data-mp="3mkrefndynled">
      <div className="min-h-screen bg-[#F8FAFC] font-body text-slate-900 flex flex-col h-screen" data-id="element-3" data-mp="3mk84otygs3bf">
        <AdminHeader data-id="element-4" data-mp="3rdkgu4lyihna" />
        <div className="flex flex-1 overflow-hidden" data-id="element-5" data-mp="3recf5n6xuth9">
          <Sidebar activeTab={activeTab} onTabChange={setActiveTab} data-id="element-6" data-mp="680frswe88f" />
          <main className="flex-1 overflow-y-auto" data-id="element-7" data-mp="2zl3cxocsjc6w">
            {activeTab === 'requetes' ? <RequetesModule data-id="element-8" data-mp="33mowttnqsqql" /> : activeTab === 'permis' ? <PermisModule data-id="element-9" data-mp="33oriy2lrxzq1" /> : activeTab === 'bciti-id' ? <BcitiIdModule data-id="element-10" data-mp="38l017ov9q91f" /> : activeTab === 'loisirs' ? <LoisirsModule data-id="element-11" data-mp="3dl4l7ovdxlwe" /> : activeTab === 'collectes' ? <BcitiCollectesModule data-id="element-12" data-mp="nvsv37yeytxj" /> : activeTab === 'compteurs' ? <BcitiCompteursModule data-id="element-13" data-mp="nxwupdpa56s0" /> : activeTab === 'atna' ? <AtnaModule data-id="element-14" data-mp="sssskuh76od1" /> : activeTab === 'settings' ? <SettingsModule data-id="element-15" data-mp="356ttacz3qbp" /> : <CreateNoticeForm data-id="element-16" data-mp="3uct4hmy40t22" />}
          </main>
        </div>
      </div>
      </AccountProvider>
      </CityProvider>
    </LanguageProvider>;
}